import {Injectable} from '@angular/core';
import {DocumentModel} from '../models/document.model';
import {NewDocumentService} from './new-document.service';

@Injectable({
    providedIn: 'root'
})
export class GenerateDocFromOrderService {

    constructor(private newDocService: NewDocumentService) {
    }

    generateDoc(doc: DocumentModel) {
        const tempDoc = this.newDocService.genNewDocument();
        tempDoc.documentType = 1;
        tempDoc.parentDocument = JSON.parse(JSON.stringify(doc));
        tempDoc.creationDate = doc.creationDate;
        tempDoc.scheduledDate = doc.creationDate;
        tempDoc.customer = doc.customer;
        tempDoc.patient = doc.patient;
        if (doc.contact) {
            tempDoc.contact = doc.contact;
        }
        if (doc.site) {
            tempDoc.site = doc.site;
        }

        return tempDoc;
    }
}
